(function () {
  angular.module('binky.core.date-utils', [
    'angularMoment',
    'binky.core.feature',
    'binky.core.lodash',
    'binky.core.src2-migration',
  ]);
})();
